import * as React from "react";
import { useState, useEffect } from "react";
import { UnmountClosed } from "react-collapse";
import { SelectEditor } from "../../../../../react-core/Html/SelectEditor";
import { ProductSort } from "../../../../../Wrap/Constants/Enums/Domain/ProductSort";
import { SubAccountType } from "../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { SortDirection } from "../../../../../Wrap/Core/SortingAndPaging/SortDirection";
import { InvestmentSelectionAction } from "../../Action/InvestmentSelectionAction";
import { AllocationTableItem } from "../../Store/SelectedInvesmentStoreStatic";
import { OffPlatformResults } from "./OffPlatformResults";
import { TextBoxEditor } from "../../../../../react-core/Html/TextBoxEditor";
import { ExternalAssetsQuery } from "../../../../../Wrap/Models/Domains/Investment/ExternalAssetsQuery";
import { ServiceProposition } from "../../../../../Wrap/Constants/Enums/ServiceProposition";

interface IOffPlatformSearchProps {
    hiercharyId: string;
    type: SubAccountType;
    tableData: AllocationTableItem[];
    index: number;
    accountServiceProposition: ServiceProposition;
    canBeBought: boolean;
    canBeSold: boolean;
    canBeTransferred?: boolean;
    TailoredDrawdownAllowed?: boolean;
}

export const OffPlatformSearch = (props: IOffPlatformSearchProps) => {
    const [showResults, setShowResults] = useState(false);
    const [managerOptions, setManagerOptions] = useState([]);
    const [investmentTypes, setInvestmentTypes] = useState([]);
    const [manager, setManager] = useState(null);
    const [investmentType, setInvestmentType] = useState(null);
    const [investmentName, setInvestmentName] = useState(null);
    const [isSearching, setIsSearching] = useState(false);
    const [data, setData] = useState(null);

    const getManagerOptions = () => {
        InvestmentSelectionAction.getExternalManager(props.hiercharyId, (data) => {
            setManagerOptions(data);
        });
    };

    const getInvestmentTypes = () => {
        InvestmentSelectionAction.getSecuritySubTypes(props.hiercharyId, "OffPlatform", (data) => {
            setInvestmentTypes(data);
        });
    };

    useEffect(() => {
        getManagerOptions();
        getInvestmentTypes();
    }, []);

    const search = (index) => {
        const query: ExternalAssetsQuery = {
            Name: investmentName,
            ManagerName: manager,
            SecuritySubType: investmentType,
            CurrentPage: index,
        };
        if (props.canBeBought) {
            query["CanBeBought"] = true;
        }
        if (props.canBeSold) {
            query["CanBeSold"] = true;
        }
        if (props.canBeTransferred) {
            query["CanBeTransferred"] = true;
        }
        
        if (!props.TailoredDrawdownAllowed) {
            query["TailoredDrawdownAllowed"] = false;
        }
        query["ProductWrapperTypes"] = [props.type];
        query["ServiceProposition"] = props.accountServiceProposition;
        query["Sorting"] = [{ Field: ProductSort.Name, Direction: SortDirection.Ascending }];
        setIsSearching(true);
        InvestmentSelectionAction.searchExternalAssets(query, props.hiercharyId, (data) => {
            setIsSearching(false);
            setData(data);
            showTableResults();
        });
    };

    const showTableResults = () => {
        setShowResults(true);
    };

    return (
        <>
            <div className="ist-advanced-panel">
                <div className="row">
                    <div className="col-fluid">
                        <SelectEditor
                            label="Manager"
                            options={managerOptions}
                            getText={(o) => o.Name}
                            onChange={(v) => setManager(v?.Name)}
                            placeholder="All"
                        />
                    </div>
                    <div className="col-fluid">
                        <SelectEditor
                            label="Investment type"
                            placeholder="All"
                            options={investmentTypes}
                            getText={(o) => o.SecuritySubTypeDisplayName}
                            onChange={(v) => { setInvestmentType(v?.SecuritySubTypeDb)}}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="col-6">
                        <TextBoxEditor
                            label="Investment"
                            onChange={(v) => { setInvestmentName(v)}}
                        />
                    </div>
                </div>

                <div className="text-right">
                    <button
                        onClick={() => search(1)}
                        type="button"
                        className={`btn secondary ${isSearching ? "is-busy" : ""}`}
                    >
                        Search
                    </button>
                </div>
            </div>

            <UnmountClosed isOpened={showResults}>
                <OffPlatformResults
                    data={data}
                    allocationTable={props.tableData}
                    onPageChange={(i) => search(i)}
                    index={props.index}
                />
            </UnmountClosed>
        </>
    );
};
